/* ============================================================
   HumaGreen — offre à durée limitée
   Décompte jusqu'à la date de fin. Le texte « jusqu'au JJ/MM/AAAA » est rendu
   par le serveur : sans JavaScript, l'information reste complète, seul le
   décompte manque. À l'échéance, tous les éléments de l'offre se retirent.
   ============================================================ */

function reste(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const jours = Math.floor(total / 86400);
  const heures = Math.floor((total % 86400) / 3600);
  const minutes = Math.floor((total % 3600) / 60);
  const secondes = total % 60;
  const deux = (n) => String(n).padStart(2, '0');

  if (jours > 0) return `${jours} j ${heures} h ${deux(minutes)} min`;
  if (heures > 0) return `${heures} h ${deux(minutes)} min`;
  return `${minutes} min ${deux(secondes)} s`;
}

function initialiserOffre() {
  const elements = [...document.querySelectorAll('[data-hg-offre]')];
  if (elements.length === 0) return;

  const formatLong = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });

  /* Date lisible : « mercredi 21 octobre » à la place de la date numérique. */
  elements.forEach((element) => {
    const fin = new Date(element.dataset.hgFin);
    if (Number.isNaN(fin.getTime())) return;
    element.querySelectorAll('[data-hg-fin-date]').forEach((noeud) => {
      noeud.textContent = formatLong.format(fin);
    });
  });

  let minuteur;
  function tic() {
    const maintenant = Date.now();
    let vivants = 0;

    elements.forEach((element) => {
      const fin = new Date(element.dataset.hgFin).getTime();
      if (Number.isNaN(fin) || fin <= maintenant) {
        element.hidden = true;
        return;
      }
      vivants += 1;
      const texte = reste(fin - maintenant);
      element.querySelectorAll('[data-hg-chrono]').forEach((chrono) => {
        if (chrono.textContent !== texte) chrono.textContent = texte;
      });
    });

    if (vivants === 0) window.clearInterval(minuteur);
  }

  tic();
  minuteur = window.setInterval(tic, 1000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialiserOffre, { once: true });
} else {
  initialiserOffre();
}
